import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { authAPI } from '../utils/api';
import { useAuth } from '../hooks/useAuth';

export default function Register({ onSwitch, isFirstUser = false }) {
  const [form, setForm] = useState({ nom: '', email: '', password: '', confirm: '', adminSecret: '', orgNom: '', orgSlug: '' });
  const [loading, setLoading] = useState(false);
  const [showSecret, setShowSecret] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) return toast.error('Les mots de passe ne correspondent pas');
    if (form.password.length < 6) return toast.error('Mot de passe trop court (6 caractères min)');
    if (!form.adminSecret) return toast.error('Code administrateur requis');
    setLoading(true);
    try {
      const payload = {
        nom: form.nom,
        email: form.email,
        password: form.password,
        adminSecret: form.adminSecret,
      };
      // Si pas premier user → créer une organisation
      if (!isFirstUser) {
        if (!form.orgNom) return toast.error('Nom de l\'organisation requis');
        payload.orgNom = form.orgNom;
        payload.orgSlug = form.orgSlug || form.orgNom.toLowerCase().replace(/\s+/g, '-');
      }
      const { data } = await authAPI.register(payload);
      login(data.token, data.user);
      toast.success(`Bienvenue, ${data.user.nom} !`);
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erreur lors de la création');
    } finally { setLoading(false); }
  };

  return (
    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 6, padding: '10px 12px', fontSize: 12, color: '#92400e' }}>
        🔐 {isFirstUser ? 'Création du compte super-administrateur' : 'Création d\'un nouveau compte avec organisation'}
      </div>

      <div className="form-group">
        <label className="form-label">Nom complet</label>
        <input className="input" type="text" placeholder="Hermann Kuate" value={form.nom} onChange={e => setForm(f => ({ ...f, nom: e.target.value }))} required />
      </div>

      <div className="form-group">
        <label className="form-label">Adresse email</label>
        <input className="input" type="email" placeholder="vous@tppartners.cm" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} required />
      </div>

      {!isFirstUser && (
        <>
          <div className="form-group">
            <label className="form-label">Nom de l'organisation *</label>
            <input className="input" placeholder="Ex: T&P Partners Douala" value={form.orgNom} onChange={e => setForm(f => ({ ...f, orgNom: e.target.value }))} required />
          </div>
          <div className="form-group">
            <label className="form-label">Identifiant organisation (optionnel)</label>
            <input className="input" placeholder="Ex: tp-partners-douala" value={form.orgSlug} onChange={e => setForm(f => ({ ...f, orgSlug: e.target.value.toLowerCase().replace(/\s+/g, '-') }))} />
          </div>
        </>
      )}

      <div className="form-group">
        <label className="form-label">Mot de passe</label>
        <input className="input" type="password" placeholder="Min. 6 caractères" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} required />
      </div>

      <div className="form-group">
        <label className="form-label">Confirmer le mot de passe</label>
        <input className="input" type="password" placeholder="Répéter" value={form.confirm} onChange={e => setForm(f => ({ ...f, confirm: e.target.value }))} required />
      </div>

      <div className="form-group">
        <label className="form-label">Code administrateur</label>
        <div style={{ position: 'relative' }}>
          <input className="input" type={showSecret ? 'text' : 'password'} placeholder="Code d'autorisation" value={form.adminSecret} onChange={e => setForm(f => ({ ...f, adminSecret: e.target.value }))} required style={{ paddingRight: 40 }} />
          <button type="button" onClick={() => setShowSecret(s => !s)} style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: 14, color: '#6b7280' }}>
            {showSecret ? '🙈' : '👁'}
          </button>
        </div>
      </div>

      <button className="btn btn-primary" type="submit" disabled={loading} style={{ padding: '11px', justifyContent: 'center', fontSize: 14 }}>
        {loading ? <><span className="spinner" style={{ width: 14, height: 14, borderTopColor: '#fff' }}></span> Création...</> : 'Créer le compte'}
      </button>

      <p style={{ textAlign: 'center', fontSize: 13, color: '#6b7280' }}>
        Déjà un compte ?{' '}
        <span onClick={onSwitch} style={{ color: '#e8192c', cursor: 'pointer', fontWeight: 500 }}>Se connecter</span>
      </p>
    </form>
  );
}
